<script>
import { useFifaGisDirectionOptions } from './duration-rules-wizzard/fifa-gis-directions-config-subform.vue'

export default {
  name: 'FifaGisDirectionsConfig',
  props: {
    config: { type: Object },
  },
  setup() {
    const { trafficModelsMap } = useFifaGisDirectionOptions()
    return { trafficModelsMap }
  },
  computed: {
    trafficModel() {
      if (this.config?.trafficModel) {
        return this.trafficModelsMap[this.config.trafficModel]
      } else {
        return 'Best guess'
      }
    },
  },
}
</script>

<template lang="pug">
.dir-grid-container
  .small-with-normal-height.text-muted.text-end Traffic model:
  span.ms-1 {{ trafficModel }}
  .small-with-normal-height.text-muted.text-end Use RMM:
  span.ms-1 {{ config?.useRmm ? 'Yes' : 'No' }}
</template>
